import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ToolbarBrickSettingsState } from '../../../../store/dashboard/brick-wall/brick-settings/specific-brick-settings/toolbar-brick-settings/toolbar-brick-settings.state';
import { BasicBrickComponent } from '../../basic-brick-component';

@Component({
   selector: 'samweb-toolbar-brick',
   templateUrl: './toolbar-brick.default.component.html',
   styleUrls: ['./toolbar-brick.default.component.scss'],
})
export class ToolbarBrickBaseComponent extends BasicBrickComponent implements OnInit {
   @Input()
   public brickInstanceId: string;

   public showVertical$: Observable<boolean>;

   constructor(protected store: Store) {
      super();
   }

   ngOnInit() {
      this.showVertical$ = this.store.select(ToolbarBrickSettingsState.getIsVerticalViewEnabled).pipe(map((fn) => fn(this.brickInstanceId)));
   }
}
